import axios from 'axios';
import { BASEURL } from '../utils/constants';

const axiosInstance = axios.create({
  baseURL: BASEURL
});

export default axiosInstance;
